import SnapshotsAdapter from './base';

export default class SnapshotSet extends SnapshotsAdapter {
  modelNamePlural = 'snapshotSets';
}
